<template>
  <div class="global-content-box global-content-flex">
    <y-menu-title />
    <div class="displayItem levelBlcok">
        <div @click="toPage('behavior')" class="item" style="width: 600px">
          <div class="left">
            <div class="titleBlock displayItem">
              <img
                src="@/assets/images/memberAll/title.png"
                alt
                style="width: 20px"
              />
              <span class="title">行为等级规则</span>
              <div style="margin-left: 50px">
                <div class="displayItem" v-if="isBehaviorStart">
                  <div class="startIcon"></div>
                  <span class="startTitle">已开启</span>
                </div>
                <div class="displayItem" v-else>
                  <span class="offTitle">未启用</span>
                  <y-button type="blue" size="mini">启用</y-button>
                </div>
              </div>
            </div>
            <div class="tips">
              直接用各订单行为指标等作为条件构成等级划分规则
            </div>
            <div class="displayItem">
              <div class="tipsIcon">例</div>
              <div class="tip">累计交易金额满200元升级至等级Lv2</div>
            </div>
          </div>
          <div class="right">
            <img
              src="@/assets/images/memberAll/behavior.png"
              alt
              style="width: 146px"
            />
          </div>
        </div>
        <div
          @click="toPage('grade')"
          class="item"
          style="margin-left: 40px; width: 600px"
        >
          <div class="left">
            <div class="titleBlock displayItem">
              <img
                src="@/assets/images/memberAll/title.png"
                alt
                style="width: 20px"
              />
              <span class="title">成长值等级规则</span>
              <div style="margin-left: 50px">
                <div class="displayItem" v-if="isGradeStart">
                  <div class="startIcon"></div>
                  <span class="startTitle">已开启</span>
                </div>
                <div class="displayItem" v-else>
                  <span class="offTitle">未启用</span>
                  <y-button type="blue" size="mini">启用</y-button>
                </div>
              </div>
            </div>
            <div class="tips">
              <div>将交易行为、互动行为等进行数值化恒量，即成长值指标。</div>
              <div>用此指标进行登记划分。</div>
            </div>
            <div class="displayItem">
              <div class="tipsIcon">例</div>
              <div class="tip">消费x元获得N成长值，满足200成长值升级至Lv2</div>
            </div>
          </div>
          <div class="right">
            <img
              src="@/assets/images/memberAll/grade.png"
              alt
              style="width: 146px"
            />
          </div>
        </div>
    </div>
    <y-title label="不同方案对比说明" style="margin-top: 16px"></y-title>
    <!-- 表格 -->
    <y-table
      :tableInfo="tableInfo"
      :tableData="gradeList"
      :autoMaxHeight="false"
    >
      <template #behavior="scope">
        <div style="color: #333;padding:6px 0px">
          <div v-for="(cont, index) in scope.row.behavior" :key="index">
            <div class="flexc-cen-x"><span class="custom-radio"></span>{{ cont.text }}</div>
          </div>
        </div>
      </template>
      <template #grade="scope">
        <div style="color: #333;padding:6px 0px">
          <div v-for="(cont, index) in scope.row.grade" :key="index">
            <div class="flexc-cen-x"><span class="custom-radio"></span>{{ cont.text }}</div>
          </div>
        </div>
      </template>
    </y-table>
  </div>
</template>

<script>
export default {
  components: {},
  props: {
    upRuleType: {
      default: "",
    },
  },
  data() {
    return {
      isGradeStart: false,
      isBehaviorStart: true,
      gradeList: [
        // 会员等级设置
        {
          gradeCode: 1,
          gradeName: "等级规则玩法",
          behavior: [
            { text: "多平台有效" },
            { text: "即使用行为项指标规则来划分会员等级" },
          ],
          grade: [
            { text: "目前仅对接了淘宝成长值等级模式" },
            { text: "用成长值来划分会员等级" },
          ],
        },
        {
          gradeCode: 2,
          gradeName: "等级规则玩法",
          behavior: [
            {
              text: "面向消费者端，规则不易透出，不易体现距离下一等级的差距和行动指导，缺乏成长动力。",
            },
          ],
          grade: [
            {
              text: "面向消费者端，有明确的等级成长规则、成长记录显示以及距离下一等级的差距，强化用户成长心智和行动",
            },
          ],
        },
      ],
      tableInfo: [
        {
          label: "",
          prop: "gradeName",
          width: "200px",
        },
        {
          label: "行为等级规则",
          prop: "behavior",
          slot: "behavior",
        },
        {
          label: "成长值等级规则",
          prop: "grade",
          slot: "grade",
        },
      ],
    };
  },
  created() {
    // 获取当前会员体系详情
    this.MemberSystemInfo = this.$store.state.MemberSystemInfo;
    console.log("this.MemberSystemInfo", this.MemberSystemInfo);
  },
  mounted() {
    console.log("this.upRuleType3", this.upRuleType);
    //判断开启状态
    if (this.upRuleType == 2) {
      this.isGradeStart = true;
      this.isBehaviorStart = false;
    } else if (this.upRuleType == 1) {
      this.isGradeStart = false;
      this.isBehaviorStart = true;
    } else {
      this.isGradeStart = false;
      this.isBehaviorStart = false;
    }
  },
  methods: {
    // 切换模块
    toPage(name) {
      this.$emit("toPage", name);
    },
  },
};
</script>

<style lang="scss" scoped>
.custom-radio {
  width: 5px;
  height: 5px;
  border-radius: 50%;
  background: #333;
  display: inline-block;
  margin-right: 8px;
}
.displayItem {
  display: flex;
  justify-content: flex-start;
  align-items: center;
}
.levelBlcok {
  .item {
    background: #f9fafc;
    border-radius: 10px 10px 10px 10px;
    opacity: 1;
    border: 1px solid #b1b1b1;
    padding: 22px 30px;
    display: flex;
    justify-content: space-between;
    align-items: center;
    .left {
      .titleBlock {
        .title {
          font-size: 16px;
          font-weight: bold;
          color: #333333;
          margin-left: 8px;
        }
        .startIcon {
          width: 10px;
          height: 10px;
          background: #00c455;
          border-radius: 20px;
          margin-right: 4px;
        }
        .startTitle {
          font-size: 16px;
          font-weight: bold;
          color: #00c455;
        }
        .offTitle {
          font-size: 12px;
          font-weight: 400;
          color: #333333;
          margin-right: 10px;
        }
        .offBtn {
          width: 60px;
          height: 28px;
          background: $theme-color;
          border-radius: 7px 7px 7px 7px;
          font-size: 12px;
          font-weight: 400;
          color: #ffffff;
          text-align: center;
          line-height: 28px;
        }
      }

      .tips {
        font-size: 12px;
        font-weight: 400;
        color: #333333;
        margin: 20px 0;
      }
      .tipsIcon {
        width: 24px;
        height: 24px;
        background: $theme-color;
        font-size: 12px;
        font-weight: 400;
        color: #ffffff;
        border-radius: 24px;
        text-align: center;
        line-height: 23px;
        margin-right: 4px;
      }
      .tip {
        font-size: 12px;
        font-weight: 400;
        color: $theme-color;
      }
    }
    .right {
      margin-left: 26px;
    }
  }
}
</style>